import React,{useState, useEffect} from 'react';
import './App.css';
import Recipe from './card';



//npm run build






function App() {
  const APP_ID="64dd6a84";
  const APP_KEY="1deebeaaf7dd5502b15d6f0926d14fc9";
  
  //we need to use states
  const [item, setItem]=useState([]);
  const[search,setSearch]=useState("chicken");
  
  useEffect(()=>{
    getData()
  },[search])

function  getData(){
    var recipeName=search;
    const url=`https://api.edamam.com/search?q=${recipeName}&app_id=${APP_ID}&app_key=${APP_KEY}`
    fetch(url)
      .catch(err=>console.log("adsf"))
      .then(res=>res.json())
      .then(data=>{console.log(data)
        // var recipe_url=data["hits"][0]['recipe']['url'];
        // var recipe_calories=data["hits"][0]['recipe']['calories'];
        // var recipe_label=data["hits"][0]['recipe']['label'];
        // var recipe_ingredients=data["hits"][0]['recipe']['ingredientLines']; //list

        //console.log(data['hits'][0]);
        setItem(data.hits);
        console.log(item);
        

      }
      )
  };

 // getData();


  return (
    <div className="mainBody">
      <h1>Recipo.Co</h1>
      <form id="search-form">
        <input type="text" name="text" placeholder="Chicken"></input>
        <button id="submit" onClick={(e)=>{
          e.preventDefault(); 
          setSearch(document.querySelector("#search-form")['text'].value);
         
        }}>Submit</button>
      </form>

      {item.map(a=>(
        <Recipe key={a['recipe']['label']} img={a['recipe']['image']} label={a['recipe']['label']} ingre={a['recipe']['ingredientLines']} url={a['recipe']['url']}/>
      )) }
      
    </div>

  );
}

export default App;
